import { Box, Grid, Skeleton } from '@mui/material';
import _ from 'lodash';
import { WishlistItemCardSkeleton } from '../../../../components/wishlist-item-card/WishlistItemCardSkeleton';
import { ProfilePageHeaderSkeleton } from '../../shared/ProfilePageHeaderSkeleton';

export const WishlistPageSkeleton = () => {
  return (
    <Box>
      <ProfilePageHeaderSkeleton hideBtn />
      <Box sx={{ borderBottom: '1px solid', borderColor: 'grey.200', overflow: 'hidden' }}>
        <Grid container columnSpacing={1} flexWrap="nowrap">
          {_.times(3).map((_item, index) => (
            <Grid key={index} item>
              <Skeleton
                variant="rectangular"
                sx={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
                height="2rem"
                width="7.5rem"
              />
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box sx={{ my: 3 }}>
        <Grid container spacing={1} justifyContent="space-between" alignItems="center">
          <Grid item>
            <Skeleton width="10rem" />
          </Grid>
          <Grid item>
            <Skeleton variant="rectangular" height="2rem" width="7.5rem" />
          </Grid>
        </Grid>
      </Box>
      <Grid container spacing={2.5}>
        {_.times(2).map((_item, index) => (
          <Grid key={index} item xs={12} md={6} xl={4}>
            <WishlistItemCardSkeleton isSubHeadingFirst />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
